









import React, { useContext, useEffect, useState } from "react";



import CircularScrollProgress from "../Circularprogress";
import { useNavigate } from "react-router-dom";
import AuthUser from "../../services/AuthUser";
import { handleRazorpayPayment } from "../../services/handlePayment";
import { ServicesContext } from "../../services/ServicesContext";
import CitySelector from "../User/CitySelectore";
import WhatsAppScrollButton from "../floatingwhatsApp";
import Footer from "../footer";
import { PartenerSheepDeedService } from "../../services/parternshipservice";
import HomeCounters from "../Homecounters";
import Testimonials from "../Testimonial";



function Drafting() {
  useEffect(() => {
    const storedUser = localStorage.getItem("user");
    if (storedUser) {
      const parsedUser = JSON.parse(storedUser);
      setNewData((prevData) => ({
        ...prevData,
        user_name: parsedUser.name || "",
        user_email: parsedUser.email || "",
        user_contact: parsedUser.mobile || "",
        user_city: parsedUser.city || "",
      }));
    }
  }, []);

  const [activeQuestion, setActiveQuestion] = useState(null);
  const { http, token } = AuthUser();
  const navigate = useNavigate();
  const toggleQuestion = (questionId) => {
    setActiveQuestion((prev) => (prev === questionId ? null : questionId));
  };

  const [newData, setNewData] = useState({ user_name: '', user_email: '', user_contact: '', user_city: '' })

  const [errors, setErrors] = useState({});

  const { services, loading, error } = useContext(ServicesContext);
  // if (loading) {
  //   return <div>Loading...</div>;  // Show loading state while fetching data
  // }

  // if (error) {
  //    return <div>{error}</div> // Show error state if there was an issue fetching data
  // }
  const service = Array.isArray(services) ? services.find(s => s.service_id === 53) : null;

  const validateForm = () => {
    const newErrors = {};

    if (!newData.user_name.trim()) {
      newErrors.user_name = 'Name is required.';
    } else if (!/^[a-zA-Z\s]+$/.test(newData.user_name)) {
      newErrors.user_name = '*Name should only contain letters and spaces.';
    }


    if (!newData.user_email.trim()) {
      newErrors.user_email = 'Email is required.';
    } else if (!/\S+@\S+\.\S+/.test(newData.user_email)) {
      newErrors.user_email = 'Enter a valid email address.';
    }

    if (newData.user_contact && !/^\d{10}$/.test(newData.user_contact)) {
      newErrors.user_contact = 'Enter a valid 10-digit contact number.';
    }

    if (!newData.user_city) {
      newErrors.user_city = 'City/District is required.';
    }

    setErrors(newErrors);
    return Object.keys(newErrors).length === 0; // No errors
  };




  const formPutPartenshipdeed = async (e) => {
    e.preventDefault();

    // ✅ Check if user is logged in
    // if (!token) {
    //   alert("Please log in to continue.");
    //   localStorage.setItem("redirectAfterLogin", window.location.pathname); // ⬅️ Save current path
    //   navigate('/login'); // 👈 Use this if you're using React Router
    //   return;
    // }
    if (!validateForm()) return;

      localStorage.setItem("bookingData", JSON.stringify(newData));

      // Navigate to checkout
      navigate('/checkout', {
         state: {
            service: service,

         }
      });

  };




  const faqList  = [
  {
    question: "How long does it take to draft a legal document?",
    answer: "The timeline varies based on document complexity. Simple agreements like NDAs or application forms may be prepared within 1-2 business days, while detailed contracts or wills may take longer, typically 3-5 business days."
  },
  {
    question: "Can you customize documents according to my specific needs?",
    answer: "Absolutely. We tailor every document to your unique circumstances and preferences, ensuring that all clauses accurately reflect your intentions and protect your interests."
  },
  {
    question: "Are the documents legally binding?",
    answer: "Yes. All documents drafted by DM2Legal comply with applicable laws and are prepared to be legally enforceable when properly executed."
  },
  {
    question: "Do you provide advice on legal matters apart from drafting?",
    answer: "While our primary focus is on drafting, we can provide general guidance related to your documents. For complex legal advice or disputes, we recommend consulting a qualified attorney."
  },
  {
    question: "What if I need to modify a document after it is drafted?",
    answer: "We offer revision services to update or amend documents as needed. Additional charges may apply based on the extent of changes required."
  },
  {
    question: "How do I submit my documents for drafting?",
    answer: "You can send us scanned copies or digital versions via email or through our secure client portal, ensuring your information is handled confidentially."
  },
  {
    question: "Do you help with document registration or notarization?",
    answer: "Yes, we can guide you through registration and notarization processes, and even connect you with trusted service providers if required."
  },
  {
    question: "Can you draft documents for business use, like MOUs or employment contracts?",
    answer: "Yes, we specialize in drafting a wide range of business documents, including MOUs, employment agreements, service contracts, and more."
  },
  {
    question: "Is there a consultation before drafting the document?",
    answer: "Yes, we begin with a brief consultation to understand your requirements, after which we collect the necessary information and documents for drafting."
  },
  {
    question: "Do you offer urgent or same-day drafting services?",
    answer: "Yes, for certain types of documents and based on workload, we offer expedited drafting for an additional fee. Please contact us directly for availability."
  }
];










  return (
    <div>


      <div className="hero-area10 header-background">
        <div className="container">
          <div className="row">
            <div className="col-lg-8">
              <div className="title title2 ">
                <div className="headding-shape aniamtion-key-2">
                  <img src="assets/img/shapes/hero8-shape2.svg" alt="" />
                </div>

                <h1 className="sk-text-color">Legal Drafting Services by DM2Legal</h1>

                <p className="pdrl-text">Get Drafting Services for only <span className="text-color">Rs.{service?.price}/- </span> <span>(Final Price, No Hidden Costs)</span></p>
                <p className="pd-text">DM2Legal offers professional legal drafting services tailored for businesses and individuals. From contracts, agreements, and legal notices to policies, affidavits, and wills—our expert team ensures every document is accurate, compliant, and legally enforceable. Trust us for reliable, customized legal paperwork that protects your interests.
                </p>

                <div className="banner">
                  <img src="assets/icons/banner.svg" alt="" srcset="" />
                </div>
              </div>
            </div>
            <div className="col-lg-4">
              <img className="hero9-shape3 aniamtion-key-1" src="assets/img/shapes/hero9-shape.svg" alt="" />
              <div className="contact3-form-all">
                <div className="hadding7">
                  <h3>Book Service Now</h3>         <p className="pdrl-text">at Rs.{service?.price}/- Only <br /> <span>(Final Price, No Hidden Costs)</span></p>
                </div>
                <form action="#">
                  <div className="form-input-all">
                    <div className="form-input-box">
                      <div className="row">
                        <div className="col-md-12">
                          <div className="input-single6">
                            <div className="">
                              <label for="">Name<span className="red">*</span></label>{errors.user_name && <p className="error-text">{errors.user_name}</p>}
                              <input type="text" placeholder="Enter your Name" value={newData.user_name} onChange={(e) => setNewData({ ...newData, user_name: e.target.value })} />
                            </div>
                          </div>
                        </div>
                        <div className="col-md-12">
                          <div className="input-single6">
                            <div className="">
                              <label for="">Email Address<span className="red">*</span></label>{errors.user_email && <p className="error-text">{errors.user_email}</p>}
                              <input type="email" placeholder="Enter your Email Address" value={newData.user_email} onChange={(e) => setNewData({ ...newData, user_email: e.target.value })} />
                            </div>
                          </div>
                        </div>
                        <div className="col-md-12">
                          <div className="input-single6">
                            <div className="">
                              <label for="">Contact Number<span className="red">*</span></label>{errors.user_contact && <p className="error-text">{errors.user_contact}</p>}
                              <input type="number" placeholder="Enter your Contact Number" value={newData.user_contact} onChange={(e) => setNewData({ ...newData, user_contact: e.target.value })} />
                            </div>
                          </div>
                        </div>
                        <div className="col-12">
                          <CitySelector
                            newData={newData}
                            setNewData={setNewData}
                            fieldKey="user_city"
                            errors={errors}
                          />
                        </div>
                      </div>
                    </div>
                    <div className="space20"></div>
                    <div className="btn-group-2">
                      <a className="theme-btn-3 btn-color" onClick={formPutPartenshipdeed} href="#">Proceed now <span><i className="fa-solid fa-arrow-right"></i></span></a>
                    </div>
                  </div>
                </form>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div className="space60 bg-white"></div>

      <div className="home4-counters bg-white">
        <div className="container">

          <div className="row">
            <div className="col-md-12">


              <HomeCounters />
            </div>
          </div>


          <div className="space40"></div>
          <div className="row">


            <div className="col-lg-12">

              {/* <h2>Annual Compliance LLP </h2> */}


              <p className="pd-text">

                {/* At DM2Legal, we understand the importance of precise and reliable legal documents in safeguarding your rights and ensuring smooth business and personal transactions. Whether you need assistance with rental agreements, affidavits, or complex contracts, our expert legal drafting services are designed to provide you with clear, comprehensive, and enforceable documents tailored to your unique needs.

Our experienced legal professionals meticulously draft a variety of legal documents to protect your interests and minimize potential disputes. From agreements that govern rental relationships to privacy policies for your business, we ensure every clause is carefully worded to comply with applicable laws and reflect your intentions accurately. */}

                At DM2Legal, we specialize in delivering precise, reliable, and legally sound drafting services tailored to your individual or business needs. Whether you're forming a new company, entering into a contract, or protecting your intellectual property, our team of experienced legal professionals ensures that every document is meticulously crafted to comply with current laws and regulations.

                Our legal drafting services include but are not limited to:

                Agreements & Contracts (Employment, Lease, Partnership, NDA, Vendor, etc.)

                Legal Notices & Affidavits

                Business Policies & Terms & Conditions

                Wills & Power of Attorney

                Petitions & Legal Applications

                Customized Legal Documents based on specific requirements

                We focus on clarity, enforceability, and risk mitigation in every draft—so you can move forward with confidence, knowing your legal documents are in expert hands. Whether you're a startup, corporation, or individual, DM2Legal is your trusted partner for professional legal drafting services.


              </p>
            </div>

          </div>


        </div>
      </div>


      <div className="last-section bg-white">
        <div className="container">
          <div className="row">
            <div className="col-lg-12">
              <div className="hadding7">
                <div className="space20"></div>
                <h2 className="aos-init aos-animate text-center">What We Offer at DM2Legal </h2>
              </div>
            </div>
          </div>
          <div className="space30"></div>
          <div className="row">
            <div className="col-md-4">
              <div className="service6-box s-box">
                <div className="box-img">
                  <div className="service-box-icon box-icon">
                    <img src="assets/img/icons/service6-icon1.png" alt="" />
                  </div>
                </div>
                <div className="hadding6">
                  <h4><a href="#" className="font-f-7">Rent Agreement</a></h4>
                  <p className="font-f-7">Secure your property rental arrangements with agreements that clearly outline terms, responsibilities, and rights of landlords and tenants.</p>
                </div>
              </div>
            </div>

            <div className="col-md-4">
              <div className="service6-box s-box">
                <div className="box-img">
                  <div className="service-box-icon box-icon">
                    <img src="assets/img/icons/service6-icon2.png" alt="" />
                  </div>
                </div>
                <div className="hadding6">
                  <h4><a href="#" className="font-f-7">NOC (No Objection Certificate)</a></h4>
                  <p className="font-f-7">Obtain official clearance documents for property, employment, or other purposes with clear and legally sound wording.</p>
                </div>
              </div>
            </div>

            <div className="col-md-4">
              <div className="service6-box s-box">
                <div className="box-img">
                  <div className="service-box-icon box-icon">
                    <img src="assets/img/icons/service6-icon3.png" alt="" />
                  </div>
                </div>
                <div className="hadding6">
                  <h4><a href="#" className="font-f-7">Affidavit</a></h4>
                  <p className="font-f-7">Prepare sworn statements that are legally valid and admissible in courts or official proceedings.</p>
                </div>
              </div>
            </div>

            <div className="col-md-4">
              <div className="service6-box s-box">
                <div className="box-img">
                  <div className="service-box-icon box-icon">
                    <img src="assets/img/icons/service6-icon5.png" alt="" />
                  </div>
                </div>
                <div className="hadding6">
                  <h4><a href="#" className="font-f-7">Power of Attorney</a></h4>
                  <p className="font-f-7">Empower trusted individuals to act on your behalf with carefully drafted authorization documents.</p>
                </div>
              </div>
            </div>

            <div className="col-md-4">
              <div className="service6-box s-box">
                <div className="box-img">
                  <div className="service-box-icon box-icon">
                    <img src="assets/img/icons/service6-icon6.png" alt="" />
                  </div>
                </div>
                <div className="hadding6">
                  <h4><a href="#" className="font-f-7">Will</a></h4>
                  <p className="font-f-7">Plan your estate and ensure your wishes are honored with a legally valid and clear last will and testament.</p>
                </div>
              </div>
            </div>

            <div className="col-md-4">
              <div className="service6-box s-box">
                <div className="box-img">
                  <div className="service-box-icon box-icon">
                    <img src="assets/img/icons/service6-icon4.png" alt="" />
                  </div>
                </div>
                <div className="hadding6">
                  <h4><a href="#" className="font-f-7">Application Forms</a></h4>
                  <p className="font-f-7">Professional drafting of application forms for various legal and administrative purposes.</p>
                </div>
              </div>
            </div>

            <div className="col-md-4">
              <div className="service6-box s-box">
                <div className="box-img">
                  <div className="service-box-icon box-icon">
                    <img src="assets/img/icons/brand6-4.png" alt="" />
                  </div>
                </div>
                <div className="hadding6">
                  <h4><a href="#" className="font-f-7">NDA Drafting</a></h4>
                  <p className="font-f-7">Protect your confidential information with enforceable NDAs customized for your business needs.</p>
                </div>
              </div>
            </div>

            <div className="col-md-4">
              <div className="service6-box s-box">
                <div className="box-img">
                  <div className="service-box-icon box-icon">
                    <img src="assets/img/icons/work6-icon3.png" alt="" />
                  </div>
                </div>
                <div className="hadding6">
                  <h4><a href="#" className="font-f-7">Privacy Policy Drafting</a></h4>
                  <p className="font-f-7">Ensure your business complies with data protection laws by clearly outlining how personal data is collected, used, and stored.</p>
                </div>
              </div>
            </div>

            <div className="col-md-4">
              <div className="service6-box s-box">
                <div className="box-img">
                  <div className="service-box-icon box-icon">
                    <img src="assets/img/icons/service6-icon5.png" alt="" />
                  </div>
                </div>
                <div className="hadding6">
                  <h4><a href="#" className="font-f-7">Terms and Conditions Drafting</a></h4>
                  <p className="font-f-7">Create clear rules and guidelines for your website or service users to limit liabilities and define usage policies.</p>
                </div>
              </div>
            </div>
          </div>

          <div className="space20"></div>
        </div>
      </div>
      <div className="service-binifits9 bg-white" >
        <div className="container">


          {/* <div className="row">
            <div className="col-lg-12">
              <div className="hadding7">
                <div className="space40"></div>
                <h2 className="text-center">How to apply</h2>
                <div className="space20"></div>
                <img src="assets/new/CMA-Report.png" />
              </div>
              <div className="space20"></div>
            </div>
          </div> */}
        </div>
      </div>
      <div className="space20 bg-white"></div>


      <div className="service-binifits9 sp0" id="service2">
        <div className="container">
          <div className="row">
            <div className="col-lg-12 text-center">
              <div className="hadding7">
                <div className="space80"></div>
                <h2>Online Registration Procedure</h2>
              </div>
              <div className="partnership-deade-section">
                <div className="space40"></div>

                <ul className="disc-list">
                  <li>
                    <h3>Step 1 <span><img className="arow" src="assets/image/blackarow.svg" alt="" /></span></h3>
                    <span>We start by thoroughly reviewing any documents or information you provide to identify inconsistencies or missing details—keeping your case risk-free and accurate.</span>
                    <svg className="pointer">
                      <path d="M6.25,1.25L11.25,11.25L1.25,11.25L6.25,1.25Z" />
                    </svg>
                  </li>
                  <li>
                    <h3>Step 2 <span><img className="arow" src="assets/image/blackarow.svg" alt="" /></span></h3>
                    <span>Our legal experts will help you collect the necessary personal, business, or supporting documents required for the service, while ensuring full regulatory compliance.</span>
                    <svg className="pointer">
                      <path d="M6.25,1.25L11.25,11.25L1.25,11.25L6.25,1.25Z" />
                    </svg>
                  </li>
                  <li>
                    <h3>Step 3 <span><img className="arow" src="assets/image/blackarow.svg" alt="" /></span></h3>
                    <span>We assess your legal objective—whether it’s a rental agreement, power of attorney, or NDA—to tailor the structure and content of the document to your exact needs.</span>
                    <svg className="pointer">
                      <path d="M6.25,1.25L11.25,11.25L1.25,11.25L6.25,1.25Z" />
                    </svg>
                  </li>
                  <li>
                    <h3>Step 4 <span><img className="arow" src="assets/image/blackarow.svg" alt="" /></span></h3>
                    <span>We draft your document based on your inputs and legal requirements. You'll get a chance to review and request any modifications before finalization.</span>
                    <svg className="pointer">
                      <path d="M6.25,1.25L11.25,11.25L1.25,11.25L6.25,1.25Z" />
                    </svg>
                  </li>
                  <li>
                    <h3>Step 5 <span><img className="arow" src="assets/image/done.svg" alt="" /></span></h3>
                    <span>After your approval, we deliver the final document in a legally valid format. If required, we also assist with registration, notarization, or government filing.</span>
                    <svg className="pointer">
                      <path d="M6.25,1.25L11.25,11.25L1.25,11.25L6.25,1.25Z" />
                    </svg>
                  </li>
                </ul>

                <div className="space80"></div>
              </div>
            </div>
          </div>


        </div>

      </div>
      <div className="container">

        <div className="row">
          <div className="col-lg-12">
            <div className="hadding7">
              <div className="space40"></div>
              <h2 className="text-center">Documents Needed for Registration</h2>
              <p className="text-center pd-text">Documents required for registration</p>
              <div className="space20"></div>
            </div>
          </div>
          <div className="col-lg-5">
            <img src="assets/img/images/Documents-Needed-for-Trademark-Registration.png" alt="" />
          </div>
          <div className="col-lg-7">
            <div className="contact6-list doc-list">
              <ul>
                <li className="font-f-7"><span><img className="arow" src="assets/image/doc-01.svg" alt="" /></span><strong>Personal Identification:</strong> Government-issued ID (e.g., passport, driver’s license, Aadhaar card)</li>

                <li className="font-f-7"><span><img className="arow" src="assets/image/doc-01.svg" alt="" /></span><strong>Property Documents:</strong> Ownership proof, sale deed, or rental details (for rent agreements, NOCs, etc.)</li>

                <li className="font-f-7"><span><img className="arow" src="assets/image/doc-01.svg" alt="" /></span><strong>Details of Parties Involved:</strong> Full names, addresses, contact information, and legal status (individual, company, etc.)</li>

                <li className="font-f-7"><span><img className="arow" src="assets/image/doc-01.svg" alt="" /></span><strong>Specific Terms:</strong> Any agreed-upon terms, obligations, or conditions to be included</li>

                <li className="font-f-7"><span><img className="arow" src="assets/image/doc-01.svg" alt="" /></span><strong>Purpose of Document:</strong> Clear explanation of the intended use and scope of the document</li>

                <li className="font-f-7"><span><img className="arow" src="assets/image/doc-01.svg" alt="" /></span><strong>Supporting Documents:</strong> Any previous agreements, consent letters, or related paperwork relevant to the drafting</li>

                <li className="font-f-7"><span><img className="arow" src="assets/image/doc-01.svg" alt="" /></span>By providing accurate and complete documentation, you enable DM2Legal to draft documents that best protect your interests and meet all legal requirements.</li>
              </ul>

            </div>
          </div>
        </div>
    <div className="space40"></div>
      </div>
      <div className="service-binifits9 sp0" id="service2" >
        <div className="space40"></div>
        <div className="container">
          <div className="row">
            <div className="col-lg-12">
              <div className="hadding7">
                <h2 className="text-center">Benefits of the legal document drafting services</h2>
                <div className="service-binifits-boxs">
                  <div className="row">
                    <div className="col-md-4">
                      <div className="single-boxs">
                        &nbsp;&nbsp;
                        <div className="icon">
                          <p> <span><img className="arow" src="assets/image/arow-01.svg" alt="" /></span>
                            Legal Clarity & Protection</p>
                        </div>
                      </div>
                    </div>
                    <div className="col-md-4">
                      <div className="single-boxs">
                        &nbsp;&nbsp;
                        <div className="icon">
                          <p> <span><img className="arow" src="assets/image/arow-01.svg" alt="" /></span>
                            Compliance with Laws</p>
                        </div>
                      </div>
                    </div>
                    <div className="col-md-4">
                      <div className="single-boxs">
                        &nbsp;&nbsp;
                        <div className="icon">
                          <p> <span><img className="arow" src="assets/image/arow-01.svg" alt="" /></span>
                            Risk Mitigation</p>
                        </div>
                      </div>
                    </div>
                    <div className="col-md-4">
                      <div className="single-boxs">
                        &nbsp;&nbsp;
                        <div className="icon">
                          <p> <span><img className="arow" src="assets/image/arow-01.svg" alt="" /></span>
                            Time & Cost Efficiency</p>
                        </div>
                      </div>
                    </div>
                    <div className="col-md-4">
                      <div className="single-boxs">
                        &nbsp;&nbsp;
                        <div className="icon">
                          <p> <span><img className="arow" src="assets/image/arow-01.svg" alt="" /></span>
                            Enforceability in Courts</p>
                        </div>
                      </div>
                    </div>
                    <div className="col-md-4">
                      <div className="single-boxs">
                        &nbsp;&nbsp;
                        <div className="icon">
                          <p> <span><img className="arow" src="assets/image/arow-01.svg" alt="" /></span>
                            Peace of Mind</p>
                        </div>
                      </div>
                    </div>
                    <div className="col-md-4">
                      <div className="single-boxs">
                        &nbsp;&nbsp;
                        <div className="icon">
                          <p> <span><img className="arow" src="assets/image/arow-01.svg" alt="" /></span>
                            Enhanced Privacy & Security</p>
                        </div>
                      </div>
                    </div>
                    <div className="col-md-4">
                      <div className="single-boxs">
                        &nbsp;&nbsp;
                        <div className="icon">
                          <p> <span><img className="arow" src="assets/image/arow-01.svg" alt="" /></span>
                            Professional Customization</p>
                        </div>
                      </div>
                    </div>
                    <div className="col-md-4">
                      <div className="single-boxs">
                        &nbsp;&nbsp;
                        <div className="icon">
                          <p> <span><img className="arow" src="assets/image/arow-01.svg" alt="" /></span>
                            Strengthens Business & Personal Credibility</p>
                        </div>
                      </div>
                    </div>

                  </div>
                </div>
              </div>
            </div>
            <div className="space30"></div>
                <div className="space40"></div>
          </div>
        </div>
      </div>


      <div className="bg-white">

        <div className="container">
          <div className="row">
            <div className="col-12">
              <div className="faq-items" id="masonry-grid">
                <div className="mesonry-item general single-price-list">
                  <div className="faqs inner-faq">
                    <h2 className="text-center">FREQUENTLY ASKED QUESTIONS</h2>
                    <div className="space30"></div>
                    <div id="general">


                      {faqList.map((faq, index) => (
                        <div className="single-faq" key={index}>
                          <h2
                            className={`faq-heading font-f-3 weight-700 ${activeQuestion === index ? '' : 'collapsed'}`}
                            id={`faq-heading${index}`}
                            onClick={() => toggleQuestion(index)}
                          >
                            Q{index + 1}: {faq.question}
                            <span>
                              {activeQuestion === index ? (
                                <img src="assets/img/icons/plus-3.svg" className="minusicon" alt="collapse icon" />
                              ) : (
                                <img src="assets/img/icons/plus-2.svg" className="plusicon" alt="expand icon" />
                              )}
                            </span>
                          </h2>
                          <div
                            id={`collapse${index}`}
                            className={`accordion-collapse collapse ${activeQuestion === index ? 'show' : ''}`}
                          >
                            <p className="font-f-3 weight-500">{faq.answer}</p>
                          </div>
                        </div>
                      ))}

                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div className="space40 bg-white"></div>
  <Testimonials/>
      <div className="last-section bg-white">
        <div className="container">
          <div className="row">
            <div className="col-lg-7 m-auto text-center">
              <div className="hadding7">
                <div className="space20"></div>
                <h2 className="aos-init aos-animate">Why Choose Us?</h2>
              </div>
            </div>
          </div>
          <div className="space30"></div>
          <div className="row">
            <div className="col-lg-6" >
              <div className="service6-box">
                <div className="">
                  <div className="service-box-icon">
                    <p>1</p>
                  </div>
                </div>
                <div className="hadding6">
                  <h4><span><img className="arow" src="assets/image/icons/growth.svg" alt="" /></span><a href="single-service-1.html" >Growth & Improvement</a></h4>
                  <p>We are committed to continuous growth and improvement. To us, growth is the fundamental principle of life, and we strive to achieve it. We understand the significance of business growth and its importance to you.</p>
                </div>
              </div>
            </div>
            <div className="col-lg-6" >
              <div className="service6-box">
                <div className="">
                  <div className="service-box-icon">
                    <p>2</p>
                  </div>
                </div>
                <div className="hadding6">
                  <h4><span><img className="arow" src="assets/image/icons/support.svg" alt="" /></span><a href="single-service-1.html" >Support & Availability</a></h4>
                  <p>We understand how even a small problem or query can cause frustration. That's why we are always available to provide support and resolve any issues you may have, whenever they arise.</p>
                </div>
              </div>
            </div>
            <div className="col-lg-6" >
              <div className="service6-box">
                <div className="">
                  <div className="service-box-icon">
                    <p>3</p>
                  </div>
                </div>
                <div className="hadding6">
                  <h4><span><img className="arow" src="assets/image/icons/team.svg" alt="" /></span><a href="single-service-1.html" >Experienced Team</a></h4>
                  <p>Our team consists of experienced professionals who prioritize professionalism and customer satisfaction above all else. Each member is passionate about their respective field and dedicated to delivering the best service.</p>
                </div>
              </div>
            </div>
            <div className="col-lg-6" >
              <div className="service6-box">
                <div className="">
                  <div className="service-box-icon">
                    <p>4</p>
                  </div>
                </div>
                <div className="hadding6">
                  <h4><span><img className="arow" src="assets/image/icons/focus.svg" alt="" /></span><a href="single-service-1.html" >Focus</a></h4>
                  <p>We treat every task with the utmost importance. Our team members remain dedicated and focused on addressing even the smallest needs and requirements of our clients.</p>
                </div>
              </div>
            </div>
            <div className="col-lg-6" >
              <div className="service6-box">
                <div className="">
                  <div className="service-box-icon">
                    <p>5</p>
                  </div>
                </div>
                <div className="hadding6">
                  <h4><span><img className="arow" src="assets/image/icons/value.svg" alt="" /></span><a href="single-service-1.html" >Value for Money</a></h4>
                  <p>We understand the value of your hard-earned money. That's why we ensure that every penny you invest with us is utilized in the most effective way, delivering the best value for your investment.</p>
                </div>
              </div>
            </div>
            <div className="col-lg-6" >
              <div className="service6-box">
                <div className="">
                  <div className="service-box-icon">
                    <p>6</p>
                  </div>
                </div>
                <div className="hadding6">
                  <h4><span><img className="arow" src="assets/image/icons/care.svg" alt="" /></span><a href="single-service-1.html" >Care & Regards</a></h4>
                  <p>We consider you a part of our family, and your challenges and successes are our own. Your interests are our priority, and we are dedicated to fulfilling them with the utmost care and attention.</p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div className="space40 bg-white"></div>

      < WhatsAppScrollButton />

      <Footer />
      <CircularScrollProgress />
    </div>

  );
}
export default Drafting;

